/* eslint-disable camelcase */

interface GetTagGroupAPIConfigParams {
    client_id: number;
}

export const createAPIConfigForGetTagGroup = ({
    client_id,
}: GetTagGroupAPIConfigParams) => ({
    url: '/api/segments',
    method: 'GET',
    params: {
        client_id,
    },
});

export interface DeleteTagGroupAPIConfigParams {
    client_id: number;
    id: number;
}

export const createAPIConfigForDeleteTagGroup = ({
    client_id,
    id,
}: DeleteTagGroupAPIConfigParams) => ({
    url: '/api/segments',
    method: 'DELETE',
    params: {
        client_id,
        id,
    },
});
